module.exports = __webpack_public_path__ + "static/media/logo-alcaldia.16e726d7.png";